export const isEmptyObject = (obj: Record<string, any>): boolean => {
  for (const _key in obj) {
    return false
  }
  return true
}
